import React from 'react';
import ClientDetailsQuestion from "./clientDetailsQuestion";
import Button from "../button";
import CenteredDots from "../General/centeredDots";
import FormResponseMessage from "../formResponseMessage";
import FormGroupSelectInput from "../formGroupSelectInput";
import _ from "lodash";
import Tooltip from "../General/tooltip";
import {isAragUser} from "../../helpers/functions";

const WizardStep1 = (props) => {
    if(props.fetchingQuoteQuestions){
        return (
            <div className={'col-sm-12'}>
                <CenteredDots/>
            </div>
        )
    }

    const noteMessage = props._getQuoteMessageByPosition('QuickQuoteNotice');
    return (
        <form className={'form-horizontal'} onSubmit={props._handleClientDetailsFormSubmit}>
            {isAragUser(props.loggedInUserRoles) && (
                <FormGroupSelectInput
                    Label={'Broker'}
                    LeftWrapper="col-sm-3"
                    Required={true}
                    Name={'broker'}
                    Value={props.selectedBroker}
                    Options={[
                        {key:'', value: ''},
                        ...props.brokers.map(broker => ({
                            key: broker.id,
                            value: `${broker.forename} ${broker.surname}`
                        }))
                    ]}
                    HandleInputChange={(evt) => props.changeQuoteRequired({
                        key: evt.target.name,
                        value: evt.target.value
                    })}
                    CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
                    SelectStyle={'form-control formGroupSelectInput-select'}
                />
            )}
            {props.quoteQuestions.map(question => {
                if(question.isParent) {
                    return (
                        <ClientDetailsQuestion
                            key={question.id}
                            question={question}
                            quoteQuestions={props.quoteQuestions}
                            clientDetailsForm={props.clientDetailsForm}
                            changeQuoteClientDetailsForm={props.changeQuoteClientDetailsForm}
                            handleSelectChange={props.handleSelectChange}
                        />
                    )
                } else return null
            })}
            <div className={'form-group'}>
                <div className={'col-sm-12'} dangerouslySetInnerHTML={{__html: noteMessage.body}}>
                </div>
            </div>
            <div className={'form-group'}>
                <div className={'col-sm-12'}>
                    <Button
                        wrapper="btn-wrapper"
                        btnType="submit"
                        btnStyle={'btn btn-primary btn-xs sharp yellow'}
                        label="Click for QuickQuote"
                    />
                </div>
                {props.postingQuote && (
                    <div className={'col-sm-12'}>
                        <CenteredDots/>
                    </div>
                )}
            </div>
            {props.postQuoteFailedMessage && (
                <FormResponseMessage
                    Message={props.postQuoteFailedMessage}
                    CenterWrapper="col-sm-6"
                    LeftWrapper="col-sm-3"
                    MessageStyle="formResponseMessage-reject"
                />
            )}
        </form>
    )
};

export default WizardStep1;